/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Reingest_ErrorInputs */

const es_tools_nexata_reingest_error = /** @type {(inputs: Tools_Nexata_Reingest_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al reindexar archivos`)
};

const en_tools_nexata_reingest_error = /** @type {(inputs: Tools_Nexata_Reingest_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error reindexing files`)
};

/**
* | output |
* | --- |
* | "Error reindexing files" |
*
* @param {Tools_Nexata_Reingest_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_reingest_error = /** @type {((inputs?: Tools_Nexata_Reingest_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Reingest_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_reingest_error(inputs)
	return en_tools_nexata_reingest_error(inputs)
});
export { tools_nexata_reingest_error as "tools.nexata.reingest_error" }